import { render } from "./WindowsTaskBar.vue?vue&type=template&id=022c6cbe&scoped=true"
import script from "./WindowsTaskBar.vue?vue&type=script&lang=js"
export * from "./WindowsTaskBar.vue?vue&type=script&lang=js"

import "./WindowsTaskBar.vue?vue&type=style&index=0&id=022c6cbe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-022c6cbe"

export default script